/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");
var debounce = require("debounce");
var window = require("global");

var InfoGetter = window.InfoGetter;

// eslint-disable-next-line node/no-missing-require
const AsyncStorage = require("@react-native-async-storage/async-storage").default;


var IS_LEGACY = !!(InfoGetter && InfoGetter.getBleSettings);

var DISCONNECT_DELAY = 4 * 60 * 1000; // 4 minutes
var BUTTON_PRESS_DELAY = 2 * 1000; // 2 seconds
var FALL_DELAY = 5 * 1000; // 5 seconds

module.exports = Model({
	name: "bracelet",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	_settings: null,
	_machines: null,
	_disconnectedTimer: null,
	_hasDisconnected: null,
	_hasWarned10: false,
	_hasWarned5: false,
	_location: "",
	_active_urgency: false,

	beginDisconnectedTimer: beginDisconnectedTimer,
	clearDisconnectedTimer: clearDisconnectedTimer,

	clearOldSettings: clearOldSettings,
});

function init() {
	return AsyncStorage.getItem("hasDisconnected")
		.then(function (closeStatus) {
			this._hasDisconnected = !!closeStatus;
			this.push({
				exists: false,
				connected: false,
				battery: -1,
				reconnecting: false,
				flashing: false,
				remoteScan: false,
				changeBattery: false,
			});
		}.bind(this));
}

function uninit() {
	this._settings = null;
	this.clearDisconnectedTimer();
}

function listeners() {
	return {
		"braceletbatterynotifier:updated": Model.makeExtender("changeBattery"),
		"braceletdata:updated": handle_bracelet_data_updated,
		"braceletowner:disconnected": handle_bracelet_disconnected,
		"braceletreconnector:updated": Model.makeExtender("reconnecting"),
		"calling:updated": handle_calling_updated,
		"connectivity:offline": handle_connectivity_offline,
		"machineevents:taken": handle_bracelet_taken,
		"ownbraceletevents:battery": handle_bracelet_battery,
		"ownbraceletevents:disconnected": handle_bracelet_disconnected,
		"ownbraceletevents:fallen": debounce(handle_bracelet_fallen, FALL_DELAY),
		"ownbraceletevents:pressed": debounce(handle_bracelet_pressed, BUTTON_PRESS_DELAY),
		"remotebraceletscanner:updated": Model.makeExtender("remoteScan"),
		"urgencycalls:updated": handle_urgency_calls_updated,
	};
}

function triggers() {
	return {
		"pressed": debounce(handle_bracelet_pressed, BUTTON_PRESS_DELAY),
		"warning": handle_trigger_warning,
		"disconnected": handle_bracelet_disconnected,
		"battery": handle_bracelet_battery,
		"alert": handle_trigger_alert,
		"clear": handle_trigger_clear
	};
}

function handle_bracelet_data_updated(settings) {
	if (IS_LEGACY) {
		var can_init = settings.mac;
		if (!can_init) return;
		InfoGetter.getBleSettings(
			true,
			true,
			true,
			false,
			30,
			10,
			15,
			false,
			"00:00",
			"23:59");
		InfoGetter.initBleService();
		return;
	}

	// Define existing bracelet settings
	var oldSettings = this._settings;
	var oldMac;
	var oldModel;
	if (oldSettings) {
		oldMac = oldSettings.mac;
		oldModel = oldSettings.model;
	}
	// Define new bracelet settings
	this._settings = settings;
	var mac = settings.mac;
	var relay = settings.relay;

	// account for legacy users where no model definition exists
	var model = settings.model ? settings.model : "vlrt";

	if (relay) {
		if (oldMac) this.clearOldSettings();
		return this.emit("bluetooth:trigger:initialize");
	}

	// If we were losing our assigned MAC
	if (!mac && oldMac) {
		this.clearOldSettings();
		// Notify the UI
		return this.extend({
			mac: "",
			model: "",
			exists: false,
			connected: false,
			battery: 0
		});
	}

	// If the MAC hasn't changed, whatever
	if (oldMac && (oldMac === mac) && (oldModel === model))
		return;

	// Clear old settings and if we don't have a mac return
	this.clearOldSettings();

	if (!mac) {
		return;
	}

	// At this point we conclude we have a new mac and model
	this.extend({
		connected: false,
		battery: 0,
		exists: mac,
		model: model
	});

	// No if the model is not 'vlrt' return because it is not
	// something that uses the VSN find/found/take/taken cycle
	if (model !== "vlrt") return;

	// Subscribe to own bracelet events for mac/model
	this.emit("ownbraceletevents:trigger:subscribe", {
		mac: mac,
		model: model
	});

	this.emit("bluetooth:trigger:initialize");

	// If 'vlrt' trigger bracelet reconnector
	if (mac && model === "vlrt") {
		// A vlrt must always be connected, metas connect as required.
		this.emit("braceletreconnector:trigger:find", {
			bracelet: this._settings.mac,
			model: this._settings.model
		});
	}
}

function clearOldSettings() {
	// Disconnect from bracelet
	this.emit("ownbraceletevents:trigger:disconnect");

	// Stop listening for old events
	this.emit("ownbraceletevents:trigger:unsubscribe");
	// If the device was currently reconnecting. Stop it.
	if (this.data.reconnecting)
		this.emit("braceletreconnector:trigger:stop");
}

function handle_calling_updated(calling) {
	var state = calling.state;
	this._state = state;
}

function handle_bracelet_pressed() {
	if (this._state === "receiving") {
		this.emit("usermetrics:trigger:track", "accept call by pressing bracelet");
		return this.emit("calling:trigger:accept", {});
	}

	var settings = this._settings || {};
	var pressAction = settings.press;

	var actionIsUrgency = (!pressAction || (pressAction === "urgency"));

	if (actionIsUrgency) {
		if (this._active_urgency) return;
		this.emit("usermetrics:trigger:track", "begin urgency call by pressing bracelet");
		return this.emit("urgencycalls:trigger:call", {
			reason: "press"
		});
	}

	if ((this._state === "connected") || (this._state === "calling")) {
		this.emit("usermetrics:trigger:track", "hangup call by pressing bracelet");
		return this.emit("calling:trigger:hangup", {
			reason: "button"
		});
	}

	if (pressAction === "none") return;

	if (pressAction !== "contact") return;
	var contact = settings.contact;
	if (!contact) return;

	// Cause the call to be made to the specified contact.
	this.emit("calling:trigger:call", {
		who: contact,
		reason: "button"
	});
	this.emit("usermetrics:trigger:track", "call contact by pressing bracelet");
}

function handle_bracelet_fallen(data) {

	var settings = this._settings;
	var mac = settings.mac;
	var machine = data.machine;

	this.api.device.track.falls(mac, machine);

	if (!settings) return;

	var fallAction = settings.fall;

	if (fallAction === "none") {
		this.emit("ownbraceletevents:trigger:alert:off", {});
	}

	if ((!fallAction || (fallAction === "urgency")) && !this._active_urgency)
		this.emit("urgencycalls:trigger:call", {
			reason: "fall"
		});
}

function handle_trigger_warning(data) {
	var min_time = data.min;
	var max_time = data.max;
	this.api.banner.warning(min_time, max_time);
}

function handle_bracelet_disconnected() {
	if (IS_LEGACY)
		return this.api.banner.warning.device.disconnected();

	if (!this.data.connected)
		return;

	this.extend({
		connected: false,
		battery: 0
	});

	// if a vlrt initiate a search for the bracelet and begin
	// the timer to determine if it's a disconnect or wander event.
	// If there is no MAC then the disconnect process ends here.
	if (this._settings.mac && this._settings.model === "vlrt") {
		this.emit("braceletreconnector:trigger:find", {
			bracelet: this._settings.mac,
			model: this._settings.model
		});
		this.beginDisconnectedTimer();
	}

}

function handle_bracelet_taken(data) {
	this._location = data.from;

	this.extend({
		connected: true
	});

	this.dispatch("connected", {
		bracelet: this._settings.mac
	});

	this.clearDisconnectedTimer();

	//Updates user 'live wandering' status but NOT user 'wander history'
	this.api.device.connection(this._location);

	if (!this._hasDisconnected) {
		return;
	}

	this._hasDisconnected = false;
	AsyncStorage.setItem("hasDisconnected", "");

	// Add reconnection to wander history
	this.api.device.wander.connects(this._location);

	if (!this._settings) return;
	var action = this._settings.disconnect;

	if (!action || action === "disconnected") {
		this.api.banner.warning.device.connected();
	} else if (action === "wandering") {
		// api call where '0 - not wandering'
		this.api.banner.warning.device.wandering(0);
	}
}

function handle_bracelet_battery(data) {
	var battery = data.battery;

	// add battery level to _data
	this.extend({
		battery: battery
	});

	// post the battery level in the dbase
	this.api.org.devices.battery(battery);
}

function handle_trigger_alert() {
	if (IS_LEGACY) return;

	this.emit("ownbraceletevents:trigger:alert:on", {});
	this.extend({
		flashing: true
	});
}

function handle_trigger_clear() {
	if (IS_LEGACY)
		return InfoGetter.clearLedFlashing();

	this.emit("ownbraceletevents:trigger:alert:off", {});

	this.extend({
		flashing: false
	});
}

function beginDisconnectedTimer() {
	if (this._disconnectedTimer) return;
	this._disconnectedTimer = setTimeout(notifyDisconnected.bind(this), DISCONNECT_DELAY);
}

function clearDisconnectedTimer() {
	var timer = this._disconnectedTimer;
	if (!timer) return;
	clearTimeout(timer);
	this._disconnectedTimer = null;
}

function notifyDisconnected() {

	this._hasDisconnected = true;
	AsyncStorage.setItem("hasDisconnected", "true");

	this._disconnectedTimer = false;

	this.api.device.wander.disconnects(this._location);

	if (!this._settings) return;
	var action = this._settings.disconnect;

	if (!action || (action === "disconnected")) {
		this.api.banner.warning.device.disconnected();
	} else if (action === "wandering") {
		// api call where '1 - wandering'
		this.api.banner.warning.device.wandering(1);
	}
}

function handle_connectivity_offline() {
	if(!this._settings.mac) return;
	var mac = this._settings.mac;
	var model = this._settings.model;

	if (!mac || model !== "vlrt") return;

	this.extend({
		connected: false
	});

	this.emit("braceletreconnector:trigger:find", {
		bracelet: mac,
		model: this._settings.model
	});
}

function handle_urgency_calls_updated(urgency) {
	this._active_urgency = urgency.active;
}
